// Pilot suppression: hide the new financial-document content_validation
// indicators emitted by Resistant.AI while we evaluate LLM-based logic checks
// in the background. Intentionally frontend-only and hardcoded so the filter
// can be unshipped quickly once the pilot stabilizes (PRODUCT-1757).
export const SUPPRESSED_FRAUD_INDICATOR_IDS = new Set([
  "paystub_content_validation_failed",
  "paystub_content_validation_passed",
  "w2_content_validation_failed",
  "w2_content_validation_passed",
  "bank_statement_content_validation_failed",
  "bank_statement_content_validation_passed",
]);

export interface SuppressibleFraudSignal {
  identifier?: string;
  name?: string;
  count?: number;
  supportingData?: Array<{ key?: string; name?: string; value?: string }>;
}

// Drops suppressed indicator IDs from a flat string[] of fraud indicator IDs
// (e.g. app.fraudIndicators / creditScoreSummary.fraudIndicators). Null-safe.
export const filterSuppressedIndicatorIds = (
  ids: ReadonlyArray<string> | null | undefined
): string[] => {
  if (!Array.isArray(ids)) {
    return [];
  }
  return ids.filter((id) => !SUPPRESSED_FRAUD_INDICATOR_IDS.has(id));
};

// Drops suppressed fraud signals from an inline display array. Each signal's
// `identifier` corresponds to the Resistant.AI indicator_id (see vega-ocr.js
// mapping), so we match on that. Never mutates the input.
export const filterSuppressedFraudSignals = <
  T extends SuppressibleFraudSignal,
>(
  signals: ReadonlyArray<T> | null | undefined
): T[] => {
  if (!Array.isArray(signals)) {
    return [];
  }
  return signals.filter(
    (signal) => !SUPPRESSED_FRAUD_INDICATOR_IDS.has(signal?.identifier ?? "")
  );
};
